export default "__VITE_ASSET__BX301ry$__"